import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  getRole;
  isValid;
  constructor() { }

  ngOnInit() {
     this.getRole = localStorage.getItem('userRole');

  }

}



// WEBPACK FOOTER //
// ./src/app/Screens/dashboard/dashboard.component.ts